import { getEnvVar } from '@vimond/utils/env';

// Global constants
export const ANIMATED_IMAGE_LOCATION = 'VIDEO_PREVIEW';
export const ANIMATED_VERTICAL_IMAGE_LOCATION = 'VERTICAL_VIDEO_PREVIEW';

// Environment variables
export const PRODUCTION_DOMAIN_URL = `https://${getEnvVar('NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL')}`;

export const DEFAULT_LANGUAGE = getEnvVar('NEXT_PUBLIC_DEFAULT_LANGUAGE');
export const TENANT = getEnvVar('NEXT_PUBLIC_TENANT');
export const ENVIRONMENT = getEnvVar('NEXT_PUBLIC_ENVIRONMENT');
export const SITE_NAME = getEnvVar('NEXT_PUBLIC_SITE_NAME');
export const IS_PROD = getEnvVar('NEXT_PUBLIC_DEPLOYED_ENV') === 'production';
export const IS_PREVIEW = getEnvVar('NEXT_PUBLIC_DEPLOYED_ENV') === 'preview';
export const CMP_HEADER = getEnvVar('NEXT_PUBLIC_EMBEDDED_CMP_HEADER');
export const CORE_PLAYER_TAG_ID =
  getEnvVar('NEXT_PUBLIC_LIVEWRAPPED_TAG_ID') ?? 'video-js';
export const DEFAULT_SUBTITLE_LANGUAGE = getEnvVar(
  'NEXT_PUBLIC_DEFAULT_SUBTITLE_LANGUAGE',
);

// Feature flags
export const LIVEWRAPPED_ENABLED =
  getEnvVar('NEXT_PUBLIC_LIVEWRAPPED_ENABLED') === 'true';

export const SOCIAL_MEDIA_SHARING_ENABLED =
  getEnvVar('NEXT_PUBLIC_ENABLE_SOCIAL_MEDIA_SHARING') !== 'false';

export const ALTERNATIVE_LAYOUT_ENABLED =
  getEnvVar('NEXT_PUBLIC_ALTERNATIVE_WATCH_LAYOUT') === 'true';

export const SHOW_VIDEO_INFO_PAGE = !ALTERNATIVE_LAYOUT_ENABLED;

export const VIDEO_OVERLAY_PLAYLIST_ENABLED =
  getEnvVar('NEXT_PUBLIC_VIDEO_OVERLAY_PLAYLIST_ENABLED') !== 'false';

export const USE_PLAYER_PROFILE =
  getEnvVar('NEXT_PUBLIC_USE_PLAYER_PROFILE_SERVICE') === 'true';

export const USE_IMAGE_BASED_PREVIEW =
  getEnvVar('NEXT_PUBLIC_USE_IMAGE_BASED_PREVIEW') === 'true';

export const USE_PLAYER_PROFILE_SERVICE =
  getEnvVar('NEXT_PUBLIC_USE_PLAYER_PROFILE_SERVICE') === 'true';

export const ENABLE_VIDEO_OVERLAY =
  getEnvVar('NEXT_PUBLIC_ENABLE_VIDEO_OVERLAY') === 'true';

// Payment method feature flags
export const PAYMENTS_ENABLED =
  getEnvVar('NEXT_PUBLIC_PAYMENTS_ENABLED') === 'true';

export const STRIPE_PAYMENTS_ENABLED =
  getEnvVar('NEXT_PUBLIC_STRIPE_PAYMENTS_ENABLED') === 'true';

export const VIPPS_PAYMENTS_ENABLED =
  getEnvVar('NEXT_PUBLIC_VIPPS_PAYMENTS_ENABLED') === 'true';

export const VIPPS_LOGIN_ENABLED =
  getEnvVar('NEXT_PUBLIC_VIPPS_LOGIN_ENABLED') === 'true';

export const TVOD_ENABLED = getEnvVar('NEXT_PUBLIC_TVOD_ENABLED') === 'true';

const ZEPHYR_HEADER_ENABLED =
  getEnvVar('NEXT_PUBLIC_ZEPHYR_HEADER') !== '' &&
  getEnvVar('NEXT_PUBLIC_ZEPHYR_HEADER') !== undefined &&
  getEnvVar('NEXT_PUBLIC_ZEPHYR_HEADER') !== null;

export const SHOW_DEFAULT_HEADER = !ZEPHYR_HEADER_ENABLED;

export const SHOW_PUBLISH_DATE =
  getEnvVar('NEXT_PUBLIC_SHOW_PUBLISH_DATE') === 'true';

export const isKilkayaEnabled =
  getEnvVar('NEXT_PUBLIC_KILKAYA_CDN_HOST') &&
  getEnvVar('NEXT_PUBLIC_KILKAYA_INSTALL_ID');

export const SITEMAP_USE_EMBEDDED_PLAYER_LOC =
  getEnvVar('SITEMAP_USE_EMBEDDED_PLAYER_LOC') === 'true';
